import { FC } from "react";
import styles from "./SplashOverlay.module.scss";

export const SplashOverlay: FC<{
  state: "visible" | "fading";
}> = ({ state }) => {
  return (
    <div
      className={styles.overlay}
      data-state={state}
      aria-live="polite"
      role="status"
    >
      <div className={styles.mark} aria-hidden="true">
        <span className={`${styles.pixel} ${styles.pixelOn}`} />
        <span className={`${styles.pixel} ${styles.pixelOn}`} />
        <span className={`${styles.pixel} ${styles.pixelOn}`} />
        <span className={`${styles.pixel} ${styles.pixelOn}`} />
        <span className={`${styles.pixel} ${styles.pixelOn}`} />
        <span className={`${styles.pixel} ${styles.pixelOff}`} />
        <span className={`${styles.pixel} ${styles.pixelOn}`} />
        <span className={`${styles.pixel} ${styles.pixelOff}`} />
        <span className={`${styles.pixel} ${styles.pixelOff}`} />
        <span className={`${styles.pixel} ${styles.pixelOn}`} />
        <span className={`${styles.pixel} ${styles.pixelOn}`} />
        <span className={`${styles.pixel} ${styles.pixelOn}`} />
      </div>
    </div>
  );
};
